var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTranslationsTabSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 45,
    viewBox: "0 0 31 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.962812 23.7675C0.962812 22.6725 1.1232 21.6015 1.42486 20.5681C3.39298 27.342 11.4975 32.5651 21.5234 33.3195V27.9765L30.0389 36.4875L21.5234 45V39.7201C9.96276 38.85 0.962812 32.0399 0.962812 23.7675ZM9.47683 5.27991V0L0.961304 8.51251L9.47683 17.0235V11.6805C19.5057 12.4349 27.609 17.658 29.5753 24.4319C29.8737 23.4 30.0374 22.3288 30.0374 21.2325C30.0374 12.9601 21.0374 6.14996 9.47683 5.27991Z",
    fill: "#00BAC7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslationsTabSelected);
export default __webpack_public_path__ + "static/media/translations-tab-selected.ab0e3cd0.svg";
export { ForwardRef as ReactComponent };